<script setup lang="ts">
import type { UIColor } from "@align/ui";
import type { BreadcrumbItem } from "~/composables/stores/breadcrumbs";

defineProps<{ breadcrumbs: BreadcrumbItem[]; colorBackground: UIColor; colorForeground: UIColor }>();
</script>

<template>
  <WidgetLayoutRowCellSingle v-if="breadcrumbs.length > 0">
    <template #widget>
      <WidgetBlank :colorBackground="colorBackground" omitClickMore>
        <template #container>
          <BreadcrumbsRow :breadcrumbs="breadcrumbs" :colorForeground="colorForeground" />
        </template>
      </WidgetBlank>
    </template>
  </WidgetLayoutRowCellSingle>
</template>
